import { OutlinedInput, OutlinedInputProps } from "@mui/material";
import { useFormContext } from "react-hook-form";

interface InputProps extends OutlinedInputProps {
  name: string;
}
export function Input(props: InputProps) {
  const { register } = useFormContext();

  return <OutlinedInput size={props.size ? props.size : "small"} id={props.name}  {...register(props.name)} {...props} />;
}
